import React from 'react';
import { StyleSheet, View } from '../base_components';

import ProgressSpinner from '../progress_spinner';

const styles = StyleSheet.create({
  progresssOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

type Props = {
  style?: any;
};

export default class ProgressOverlay extends React.PureComponent<Props> {
  render() {
    const { style } = this.props;
    return (
      <View style={[styles.progresssOverlay, style]}>
        <ProgressSpinner />
      </View>
    );
  }
}
